export class ProductSort {
    PageNumber: number = 1;
    PageSize: number = 10;
    KeyWord: string = "";
    CategoryNames: string;
    CategoryIds: string;
    CategoryId: string;
    Keyword: string;
    IsJustAdded: boolean;
    ProductType: any;
}
export class ProductResponseModel {
    ProductSort: Array<ProductModel> = [];
    TotalPages: number;
}

export class ProductModel {
    priceFormatted: string;
    description: string;
    discountPercent: number;
    features: string;
    isDiscount: boolean;
    productId: number;
    productName: string;
    productPrice: number;
    productPriceFormatted: string;
    productTitle: string;
    fileTitle: string;
    productImage: any;
    imageLoader: boolean = true;
    isActive: string;
    isSale: string;
    isQuote: boolean;
    isShippingRequired: string;
    productType: any;
}

export class Order {
    OrderId: string;
    UserId: number; 
    ProductId: number;
    Price: number;
}

export class CheckoutDataVM {
    productId: number;
    addressId: number;
    productTitle: string;
    isShowDiscount: boolean;
    productPrice: string;
    productPriceFormatted: string;
    discountPercent: number;
    discountAmount: string;
    finalPrice: string;
    finalPriceFormatted: string;
    zipCode: string;
    taxrate: string;
    totalPrice: string;
    totalPriceFormatted: string;
    discountAmountFormatted: string;
    applicationServicePriceFormatted: string;
    warrantyPriceFormatted: string;
    rateId: string;
    shipmentId: string;
    deliveryPriceFormatted: string;
    isDeliveryAvailable: boolean;
    estimatedDeliveryDays: string;
    grandTotalPriceFormatted: string;
    isShippingRequired: string;
    productType: any;
}

export class OrderPlaceModel {       
     ProductId: number;
     AddressId: string;
     PaymentId: string;
     WarrantyId: string;
     WarrantyPriceId: string;
     IsApplicationPriceSelected: string;  
     RateId: string;     
}

export class OrderPDFModel {
    addressId: string;
    addressNote: string;
    addressTitle: string;
    city: string;
    country: string;
    discount: string;
    landmark: string;
    orderId: string;
    price: string;
    productId: string;
    productName: string;
    productTitle: string;
    state: string;
    totalPrice: string;
    zipcode: string;
    AddressTitle: string;
}

export class OrderProductModel {
    description: string;
    discountPercent: number;
    features: string;
    isDiscount: boolean;
    productId: number;
    productName: string;
    productPrice: number;
    productTitle: string;
    productImage: any;
    imageLoader: boolean = true;
    filePath: string;
    fileTitle: string;
    ImageLoader: boolean = true;
    categoryNames: string;
    isShippingRequired: string;
}

export class CustomerOrderProductModel {
    CustomerOrderList: Array<OrderProductModel> = [];
}

export class GetAddressModel {
    id:number; 
    orderId:string;
    userId:number;
    productId:number;
    price:number;
    dateFormatted:string;
    addressId:number;
    addressTitle:string;
    city:string;
    state:string;
    country:string;
    landmark:string;
    addressNote:string;
    zipcode:number;
    productName:string;
    productTitle:string;
    totalPrice:number;
    discount:number;
    discountFormatted : string;
    isShowDiscount:boolean;
    paymentId:number;
    orderStatus:number;
    isDiscount: boolean = false;
    warrantyServiceTerm: string;
    warrantyYear: string;
    duration: string;
    title: string;
    installationPrice: string;
    warrantyPrice: string;
    applicationInstallationPrice: string;
    warrantyId: string;
    taxRate: number;
    priceFormatted : string;
    totalPriceFormatted : string;
    discountedPriceFormatted :string;
   
 }

 export class ProductTypeModel {
    ProductType : any;
    newToggle: any;
 }

 export class ProductTypeSort {
    PageNumber: number = 1;
    PageSize: number = 8;
    KeyWord: string = "";
    CategoryNames: string;
    CategoryIds: string;
    CategoryId: string;
    Keyword: string;
    IsJustAdded: boolean;
    ProductType: any;
}
